// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1F7N2","info":"UpdateTermsInfo_info__3C36Q"};